import React from "react";

const GridError = ({ error }) => (
  <div className='ec-grid-error'>{error}</div>
);

export default GridError;
